export default "__VITE_ASSET__Bxci_H4G__"